import {
    CONTACT_FIELDS,
    enabledName,
    omitContactFields,
    requiredName,
    type ContactField,
} from '@features/ContactFieldsSettings/fields';

const AGENT_FIELD_PREFIXES: Record<ContactField, string> = {
    email: 'contactEmail',
    phone: 'contactPhoneNumber',
    name: 'contactName',
    sex: 'contactSex',
    dateOfBirth: 'contactDateOfBirth',
};

const AGENT_NAMES = Object.fromEntries(
    CONTACT_FIELDS.flatMap(field => [
        [enabledName(field), `${AGENT_FIELD_PREFIXES[field]}Enabled`],
        [requiredName(field), `${AGENT_FIELD_PREFIXES[field]}Required`],
    ]),
);

type Values = Record<string, unknown>;

export const fromAgentContactFields = (agent: Values): Record<string, boolean> =>
    Object.fromEntries(Object.entries(AGENT_NAMES).map(([name, agentName]) => [name, !!agent[agentName]]));

export const toAgentValues = (values: Values): Values => ({
    ...omitContactFields(values),
    ...Object.fromEntries(Object.entries(AGENT_NAMES).map(([name, agentName]) => [agentName, !!values[name]])),
});
